(() => {
  if (window.AplovioMobileNative || window.Shopify?.designMode) return;
  const header = document.querySelector('aplovio-header[data-mobile-native]');
  if (!header) return;

  const mobile = matchMedia('(max-width:989px)');
  const departureKey = 'aplovio-mobile-departure';
  const backLink = header.querySelector('[data-mobile-native-back]');
  let restoreController, restoreFrame, restoreTimer, departure, returning = false;

  function localURL(value) {
    if (typeof value !== 'string' || !value) return null;
    try {
      const url = new URL(value, location.href);
      return url.origin === location.origin ? url : null;
    } catch { return null; }
  }

  const pageKey = url => url.pathname + url.search;
  const productURL = url => /\/products\/[^/]+\/?$/.test(url.pathname);
  const listing = () => ['collection', 'search', 'index'].includes(document.body.dataset.apPage);
  const ordinaryClick = event => !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;

  function updateState(values) {
    // History/storage can be unavailable in restricted webviews. Links still navigate normally.
    try { history.replaceState({...history.state, ...values}, '', location.href); }
    catch { /* Native navigation and the Back link remain usable. */ }
  }

  function remember(link) {
    if (!mobile.matches || !listing() || window.AplovioLayers?.top()) return;
    updateState({aplovioMobileScroll: {
      url: location.href,
      x: scrollX,
      y: scrollY,
      focus: link?.href || (history.state?.aplovioMobileScroll?.url === location.href ? history.state.aplovioMobileScroll.focus : null)
    }});
  }

  function restorePosition() {
    restoreController?.abort();
    const saved = history.state?.aplovioMobileScroll;
    const url = localURL(saved?.url);
    if (!mobile.matches || !listing() || !url || pageKey(url) !== pageKey(location) || !Number.isFinite(saved.y) || saved.y < 0) return;

    const controller = restoreController = new AbortController();
    const options = {signal: controller.signal};
    const stop = () => controller.abort();
    // Once the shopper interacts, late layout work must not move their viewport.
    for (const type of ['pointerdown', 'touchstart', 'wheel', 'keydown']) window.addEventListener(type, stop, {...options, passive: true});
    controller.signal.addEventListener('abort', () => {
      cancelAnimationFrame(restoreFrame);
      clearTimeout(restoreTimer);
    }, {once: true});

    const restore = () => {
      cancelAnimationFrame(restoreFrame);
      restoreFrame = requestAnimationFrame(() => {
        if (controller.signal.aborted) return;
        if (pageKey(url) !== pageKey(location)) { stop(); return; }
        // The collection owner refetches appended pages; never cache their HTML or prices here.
        if (document.querySelector('aplovio-collection-products')?.restoring) return;
        window.scrollTo({left: Number.isFinite(saved.x) ? saved.x : 0, top: saved.y, behavior: 'instant'});
        const link = [...document.querySelectorAll('main a[href]')].find(node => node.href === saved.focus && node.getClientRects().length);
        link?.focus({preventScroll: true});
        header.update?.();
        stop();
      });
    };
    document.addEventListener('aplovio:collection-restored', restore, options);
    restoreTimer = setTimeout(stop, 30000);
    restore();
  }

  function prepareBack() {
    if (!backLink) return;
    let departure;
    try {
      departure = JSON.parse(sessionStorage.getItem(departureKey) || 'null');
      sessionStorage.removeItem(departureKey);
    } catch { /* Storage is optional; the rendered catalogue link is the fallback. */ }
    const target = localURL(departure?.to);
    const source = localURL(departure?.from);
    const referrer = localURL(document.referrer);
    const age = Date.now() - departure?.at;
    if (target && source && referrer && target.pathname === location.pathname && pageKey(source) === pageKey(referrer) && age >= 0 && age < 60000) {
      updateState({aplovioMobileReturn: {from: source.href, product: location.pathname}});
    }
    const previous = history.state?.aplovioMobileReturn;
    const returnURL = localURL(previous?.from);
    if (previous?.product === location.pathname && returnURL) backLink.href = returnURL.href;
  }

  prepareBack();
  document.addEventListener('click', event => {
    if (!mobile.matches || !ordinaryClick(event)) return;
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self') || link.hasAttribute('data-zoom')) return;

    if (link === backLink) {
      const previous = history.state?.aplovioMobileReturn;
      if (previous?.product === location.pathname && localURL(previous.from) && history.length > 1) {
        event.preventDefault();
        if (!returning) { returning = true; history.back(); }
      }
      return;
    }

    const target = localURL(link.href);
    if (!target || !productURL(target) || pageKey(target) === pageKey(location)) return;
    // Record the intent without intercepting it. Commit only on pagehide, after all
    // app click handlers have run and the browser actually leaves this document.
    departure = {event, link, from: location.href, to: target.href, at: Date.now()};
  });

  window.addEventListener('pagehide', () => {
    restoreController?.abort();
    const leaving = departure && !departure.event.defaultPrevented && departure.from === location.href && Date.now() - departure.at < 60000;
    remember(leaving ? departure.link : null);
    if (leaving) {
      const {from, to, at} = departure;
      try { sessionStorage.setItem(departureKey, JSON.stringify({from, to, at})); }
      catch { /* Back still has its normal catalogue URL when storage is blocked. */ }
    }
    departure = null;
  });
  window.addEventListener('pageshow', () => { returning = false; departure = null; restorePosition(); });
  window.addEventListener('popstate', () => { returning = false; departure = null; });
  window.AplovioMobileNative = {getDiagnostics: () => ({engine: 'native', mobile: mobile.matches})};
})();
